import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIdea = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 1.66666C15.5798 1.66666 11.3405 3.42261 8.21493 6.54822C5.08932 9.67382 3.33337 13.9131 3.33337 18.3333C3.33337 22.7536 5.08932 26.9928 8.21493 30.1184C11.3405 33.244 15.5798 35 20 35C24.4203 35 28.6595 33.244 31.7852 30.1184C34.9108 26.9928 36.6667 22.7536 36.6667 18.3333C36.6667 13.9131 34.9108 9.67382 31.7852 6.54822C28.6595 3.42261 24.4203 1.66666 20 1.66666Z",
			fill: "#FFF59D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.8333 18.3333C30.8333 11.9167 25.3333 6.83333 18.75 7.58333C13.75 8.16666 9.75002 12.1667 9.25002 17.1667C8.83335 21 10.4167 24.4167 13.0834 26.5833C14.25 27.5833 15 29 15 30.5833V30.8333H25V30.75C25 29.25 25.6667 27.75 26.8333 26.75C29.25 24.75 30.8333 21.75 30.8333 18.3333Z",
			fill: "#FBC02D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.5 16.8333L23 15.1667C22.75 15 22.3333 15 22.0833 15.1667L20 16.5L18 15.1667C17.75 15 17.3333 15 17.0833 15.1667L14.5833 16.8333C14.4167 17 14.25 17.1667 14.25 17.4167C14.25 17.6667 14.25 17.9167 14.4167 18.0833L17.5833 22V30.8333H19.25V21.6667C19.25 21.5 19.1667 21.3333 19.0833 21.1667L16.3333 17.75L17.5833 16.9167L19.5833 18.25C19.8333 18.4167 20.25 18.4167 20.5 18.25L22.5 16.9167L23.75 17.75L21 21.1667C20.9167 21.3333 20.8333 21.5 20.8333 21.6667V30.8333H22.5V22L25.6667 18.0833C25.8333 17.9167 25.9167 17.6667 25.8333 17.4167C25.75 17.1667 25.6667 16.9167 25.5 16.8333Z",
			fill: "#FFF59D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 34.1667C19.337 34.1667 18.7011 34.4301 18.2322 34.8989C17.7634 35.3677 17.5 36.0036 17.5 36.6667C17.5 37.3297 17.7634 37.9656 18.2322 38.4344C18.7011 38.9033 19.337 39.1667 20 39.1667C20.663 39.1667 21.2989 38.9033 21.7678 38.4344C22.2366 37.9656 22.5 37.3297 22.5 36.6667C22.5 36.0036 22.2366 35.3677 21.7678 34.8989C21.2989 34.4301 20.663 34.1667 20 34.1667Z",
			fill: "#5C6BC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.6667 37.5H18.3333C16.5 37.5 15 36 15 34.1667V30H25V34.1667C25 36 23.5 37.5 21.6667 37.5Z",
			fill: "#9FA8DA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 34.1667L15.3333 35.5C15.5833 36.0833 16.0833 36.6667 16.6667 37L24.5 35.9167C24.8333 35.4167 25 34.8333 25 34.1667ZM15 32.25V33.9167L25 32.5V30.8333L15 32.25Z",
			fill: "#5C6BC0"
		})
	]
});
export default SvgIdea;
